export class PalletCapacityReq{
    palletCapacityId: number;

    constructor(palletCapacityId: number){
        this.palletCapacityId = palletCapacityId;
    }
}